export default __webpack_public_path__ + "static/media/CNo.90-4.ccf566cb.jpg";